import { ReactElement } from 'react'

import IconCategory2Icon from '@/components/common/icons/IconCategory2'
import IconCategoryBoldIcon from '@/components/common/icons/IconCategoryBold'
import IconClipboardTextIcon from '@/components/common/icons/IconClipboardText'
import IconClipboardTextBoldIcon from '@/components/common/icons/IconClipboardTextBold'
import IconPen2Icon from '@/components/common/icons/IconPen2'
import IconPen2BoldIcon from '@/components/common/icons/IconPen2Bold'
import IconPinIcon from '@/components/common/icons/IconPin'
import IconPinBoldIcon from '@/components/common/icons/IconPinBold'
import IconProfileBoldIcon from '@/components/common/icons/IconProfileBold'
import IconProfileOutlineIcon from '@/components/common/icons/IconProfileOutline'

export interface IFormStepperData {
  id: number
  url: 'info' | 'category' | 'document-upload' | 'address' | 'contract'
  completeIcon: ReactElement
  icon: ReactElement
  subTitle: string
  title: string
}

export const FormStepperData: IFormStepperData[] = [
  {
    id: 0,
    url: 'info',
    completeIcon: <IconProfileBoldIcon />,
    icon: <IconProfileOutlineIcon />,
    subTitle: 'مرحله 1 از 5',
    title: 'مشخصات'
  },
  {
    id: 1,
    url: 'category',
    completeIcon: <IconCategoryBoldIcon />,
    icon: <IconCategory2Icon />,
    subTitle: 'مرحله 2 از 5',
    title: 'دسته‌بندی'
  },
  {
    id: 2,
    url: 'address',
    completeIcon: <IconPinBoldIcon />,
    icon: <IconPinIcon />,
    subTitle: 'مرحله 3 از 5',
    title: 'آدرس'
  },
  {
    id: 3,
    url: 'document-upload',
    completeIcon: <IconClipboardTextBoldIcon />,
    icon: <IconClipboardTextIcon />,
    subTitle: 'مرحله 4 از 5',
    title: 'بارگذاری مدارک'
  },
  {
    id: 4,
    url: 'contract',
    completeIcon: <IconPen2BoldIcon />,
    icon: <IconPen2Icon />,
    subTitle: 'مرحله 5 از 5',
    title: 'امضای قرارداد'
  }
]
